import {Select} from 'antd'
import {Box, Typography} from '@mui/material'
import {WEEK_DAY_OPTIONS, TIMESLOT_OPTIONS} from '../../utils/day-time'
import {FlexColumnStyled, FormStyle, SlotSelector, SlotSelectorContainer} from './TimeslotsSelectorStyled'
import {TimeslotProps} from 'src/types/types'
// eslint-disable-next-line no-restricted-imports -- new-style button used here for visual consistency
import Button from 'src/components-new/primitives/Button'
// eslint-disable-next-line no-restricted-imports -- new-style action icon for visual consistency
import ActionIconButton from 'src/components-new/primitives/ActionIconButton'

const LABEL_SX = {fontSize: 12, fontWeight: 500, color: '#374151', lineHeight: 1, mb: '6px', display: 'block'} as const

interface TimeslotSelectorProps {
  value?: TimeslotProps;
  onChange: (value: TimeslotProps) => void;
}

export function TimeslotSelector ({
  value = {},
  onChange
}: TimeslotSelectorProps) {
  return (
    <SlotSelector>
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Typography component="span" sx={LABEL_SX}>Giorno</Typography>
        <Select
          getPopupContainer={(trigger) => trigger}
          onSelect={(day: string) => onChange({...value, day})}
          options={WEEK_DAY_OPTIONS}
          placeholder='Seleziona'
          style={{width: '100%'}}
          value={value.day}
        />
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Typography component="span" sx={LABEL_SX}>Dalle</Typography>
        <Select
          getPopupContainer={(trigger) => trigger}
          onSelect={(from: string) => onChange({...value, from})}
          options={TIMESLOT_OPTIONS}
          placeholder='--:--'
          style={{width: '100%'}}
          value={value.from}
        />
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Typography component="span" sx={LABEL_SX}>Alle</Typography>
        <Select
          getPopupContainer={(trigger) => trigger}
          onSelect={(to: string) => onChange({...value, to})}
          options={TIMESLOT_OPTIONS}
          placeholder='--:--'
          style={{width: '100%'}}
          value={value.to}
        />
      </Box>
    </SlotSelector>
  )
}

interface TimeslotsSelectorProps {
  value?: TimeslotProps[];
  onChange: (value: TimeslotProps[]) => void;
}

export default function TimeslotsSelector ({
  value = [],
  onChange
}: TimeslotsSelectorProps) {
  const onAddTimeslot = () => {
    onChange([
      ...value,
      {day: undefined, from: undefined, to: undefined}
    ])
  }

  const onEditTimeslot = (index: number, timeslot: TimeslotProps) => {
    const updatedTimeslots = [...value]
    updatedTimeslots[index] = timeslot
    onChange(updatedTimeslots)
  }

  const onDeleteTimeslot = (index: number) => {
    const updatedTimeslots = [...value]
    updatedTimeslots.splice(index, 1)
    onChange(updatedTimeslots)
  }

  const timeslotSelectors = value.map((timeslot, index) => (
    <SlotSelectorContainer key={index}>
      <TimeslotSelector
        onChange={(item: TimeslotProps) => onEditTimeslot(index, item)}
        value={timeslot}
      />
      <ActionIconButton
        variant="delete"
        onClick={() => onDeleteTimeslot(index)}
        sx={{flexShrink: 0}}
      />
    </SlotSelectorContainer>
  ))

  return (
    <FlexColumnStyled>
      <Button variant="secondary" onClick={onAddTimeslot} sx={{alignSelf: 'flex-start'}}>
        {'Aggiungi fascia oraria'}
      </Button>
      <FormStyle>
        {timeslotSelectors}
      </FormStyle>
    </FlexColumnStyled>
  )
}
